import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import LandingNavbar from '../../components/LandingNavbar';
import LandingFooter from '../../components/LandingFooter';
import '../LandingPage.css';

const DailyExpenseTracker = () => {
  return (
    <div className="seo-page">
      <Helmet>
        <title>Daily Expense Tracker App | Roz Ka Kharcha Track Karein | Hisab OK Hai</title>
        <meta name="description" content="Roz ka kharcha easily track karein. Daily expense entry, automatic reports, category-wise breakdown. India ka simple aur free daily expense tracker app." />
        <meta name="keywords" content="daily expense tracker, roz ka kharcha tracker, daily kharcha app, daily expense manager india, expense diary app, money diary india" />
        <link rel="canonical" href="https://hisabokhai.in/daily-expense-tracker" />
      </Helmet>

      <LandingNavbar />

      <section className="seo-page-hero">
        <h1>Daily Expense Tracker — Roz Ka Kharcha Track Karein</h1>
        <p>Har din ka kharcha record karein aur mahine ke end mein jaanein ki paisa kahan gaya. Simple, fast aur free.</p>
        <Link to="/signup" className="cta-primary">Free Mein Try Karein</Link>
      </section>

      <div className="seo-content">
        <h2>Har Din Ka Hisab Rakhna Kyun Zaroori?</h2>
        <p>
          Jab aap daily expenses track karte ho, toh aapko exactly pata hota hai ki paisa kahan ja raha hai.
          Chhote chhote kharche milke bade amount ban jaate hain — aur bina tracking ke yeh invisible rehte hain.
          Daily tracking se aap unnecessary expenses identify kar sakte ho aur zyada save kar sakte ho.
        </p>

        <h2>Hisab OK Hai Se Daily Tracking Kaise Karein?</h2>
        <p>
          Simple 3-step process — open app, amount daalo, category select karo, save. Bas. 10 second mein entry ho jaati hai.
        </p>
        <ul>
          <li>Quick expense entry — amount, category, description</li>
          <li>Date-wise transaction history</li>
          <li>Daily summary dashboard</li>
          <li>Category-wise breakdown — food, transport, shopping, bills</li>
          <li>Monthly comparisons — is mahine zyada kharcha hua ya kam</li>
          <li>Charts aur graphs se visual understanding</li>
        </ul>

        <h2>Categories Jo India Ke Liye Relevant Hain</h2>
        <p>
          Pre-built categories milti hain jo Indian daily life ke liye perfect hain — groceries, chai/snacks,
          auto/cab, mobile recharge, electricity bill, rent, medical, aur bahut kuch. Plus apni custom categories bhi bana sakte ho.
        </p>

        <h2>Reports Se Samjho Paisa Kahan Jaata Hai</h2>
        <p>
          Daily, weekly, monthly reports automatically generate hoti hain. Category-wise pie charts dikhate hain
          ki sabse zyada paisa kahan kharcha ho raha hai. Yeh insight se aap budget plan kar sakte ho.
        </p>

        <div className="seo-cta-box">
          <h3>Try Hisab OK Hai for Free</h3>
          <p style={{color: '#555', marginBottom: '16px'}}>Aaj se daily tracking shuru karein — 2 minute mein signup, turant use karo.</p>
          <Link to="/signup" className="cta-primary">Free Sign Up</Link>
          <div style={{marginTop: '12px'}}>
            <Link to="/login" style={{color: '#27AE60', fontSize: '0.9rem'}}>Already have an account? Login</Link>
          </div>
        </div>

        <div className="seo-internal-links">
          <h3>Explore More Features</h3>
          <div className="seo-links-grid">
            <Link to="/" className="seo-link-card">
              <span className="seo-link-icon">&#127968;</span> Home
            </Link>
            <Link to="/expense-tracker-india" className="seo-link-card">
              <span className="seo-link-icon">&#128176;</span> Expense Tracker
            </Link>
            <Link to="/udhari-management-app" className="seo-link-card">
              <span className="seo-link-icon">&#128221;</span> Udhari Management
            </Link>
            <Link to="/budget-planner-india" className="seo-link-card">
              <span className="seo-link-icon">&#128200;</span> Budget Planner
            </Link>
          </div>
        </div>
      </div>

      <LandingFooter />
    </div>
  );
};

export default DailyExpenseTracker;
